export default __webpack_public_path__ + "static/media/burger.17437f3e.jpg";